import { getUTCDate } from '@/shared/utils/date';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { CommitmentForecastValueDto } from '../../../../../types';
import MobileSumFooter from './mobileSumFooter';

interface MobileTableProps {
  tableData: CommitmentForecastValueDto[];
  openOpportunityDetailsPage: (id: string) => void;
}

const MobileTable = ({ tableData, openOpportunityDetailsPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: CommitmentForecastValueDto }) => {
    return (
      <CustomMobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>Commitment</MobileRowTitle>
          <MobileRowValue onClick={() => openOpportunityDetailsPage(el.investmentId)} isRedirect>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        {el.data.map((item) => (
          <MobileRow key={item.date}>
            <MobileRowTitle>{getUTCDate(new Date(item.date)).toUpperCase()}</MobileRowTitle>
            <MobileRowValue>
              <FormattingTooltip zIndex={1000}>{item.value}</FormattingTooltip>
            </MobileRowValue>
          </MobileRow>
        ))}
      </CustomMobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData?.length ? (
        <>
          {tableData.map((el) => {
            return <TableRow el={el} key={el.id} />;
          })}
          <MobileSumFooter tableData={tableData} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer.base};
`;
